<div class="simple-text-section {{editorClasses}}" (mouseover)="hoverOver(true)" (mouseout)="hoverOver(false)">
  <mat-form-field *ngIf="!readOnly">
    <input matInput class="simple-text-section-editor" [(ngModel)]="text" [format]="format" [readOnly]="false"
      [modules]="quillModules">
  </mat-form-field>
  <span *ngIf="readOnly" class="simple-text-section-editor">{{textTransformed}}</span>
  <div class="simple-text-section-controls" [@crossfade]="controlsEnabled ? 'show' : 'hide'">
    <button *ngIf="editAvailable" [disabled]="!editToggleEnabled" mat-raised-button
      class="edit-toggle action-button action-button-small" (click)="readOnly = !readOnly">
      <mat-icon>edit</mat-icon>
    </button>

    <ng-container *ngFor="let action of actions">
      <button *ngIf="action.doAction && action.available" mat-raised-button class="action-button action-button-small"
        (click)="action.doAction()" disabled="{{!action.enabled}}">
        <mat-icon *ngIf="action.icon">{{action.icon}}</mat-icon><span *ngIf="action.title">{{action.title}}</span>
      </button>
    </ng-container>
  </div>
</div>